import React, { ReactElement } from 'react'
import Form from '../Form'
import { FormItemType } from '../FormItem'
import StatisticsRowItem from '../RowItem/StatisticsRowItem'

type Props = {
    form?: FormItemType[]
}

const StandingsForm = ({ form }: Props): ReactElement | null => {
    if (form) {
        return (
            <StatisticsRowItem display={['none', 'none', 'none', 'flex']} width={[54, 54, 96, 96]}>
                <Form form={form} />
            </StatisticsRowItem>
        )
    }
    return null
}

export default StandingsForm
